// Importing Product Card Images
import Product1 from "../images/ProductImages/armchair-400x400.jpg";
import Product2 from "../images/ProductImages/chair-1-400x400.jpg";
import Product3 from "../images/ProductImages/chair-400x400.jpg";
import Product4 from "../images/ProductImages/couch-400x400.jpg";
import Product5 from "../images/ProductImages/desk-table-400x400.jpg";
import Product6 from "../images/ProductImages/dining-table-400x400.jpg";
import Product7 from "../images/ProductImages/fancy-chairs-400x400.jpg";
import Product8 from "../images/ProductImages/luxury-chair-400x400.jpg";
import Product9 from "../images/ProductImages/office-table-400x400.jpg";
import Product10 from "../images/ProductImages/pic53-free-img-600x600.jpg";
import Product11 from "../images/ProductImages/round-sofa-400x400.jpg";
import Product12 from "../images/ProductImages/round-stool-400x400.jpg";
import Product13 from "../images/ProductImages/safa-2-400x400.jpg";
import Product14 from "../images/ProductImages/sofa-400x400.jpg";
import Product15 from "../images/ProductImages/study-table-400x400.jpg";
import Product16 from "../images/ProductImages/table-400x400.jpg";
import Product17 from "../images/ProductImages/wooden-rocking-chair-400x400.jpg";
import Product18 from "../images/ProductImages/wooden-study-table-400x400.jpg";

// Importing Single Product Page Image
import SingleProduct1 from "../images/SingleProductImages/armchair.jpg"
import SingleProduct2 from "../images/SingleProductImages/chair-1.jpg"
import SingleProduct3 from "../images/SingleProductImages/chair.jpg"
import SingleProduct4 from "../images/SingleProductImages/couch.jpg"
import SingleProduct5 from "../images/SingleProductImages/desk-table.jpg"
import SingleProduct6 from "../images/SingleProductImages/dining-table.jpg"
import SingleProduct7 from "../images/SingleProductImages/fancy-chairs.jpg"
import SingleProduct8 from "../images/SingleProductImages/luxury-chair.jpg"
import SingleProduct9 from "../images/SingleProductImages/office-table.jpg"
import SingleProduct10 from "../images/SingleProductImages/pic53-free-img.jpg"
import SingleProduct11 from "../images/SingleProductImages/round-sofa.jpg"
import SingleProduct12 from "../images/SingleProductImages/round-stool.jpg"
import SingleProduct13 from "../images/SingleProductImages/safa-2.jpg"
import SingleProduct14 from "../images/SingleProductImages/sofa.jpg"
import SingleProduct15 from "../images/SingleProductImages/study-table.jpg"
import SingleProduct16 from "../images/SingleProductImages/table.jpg"
import SingleProduct17 from "../images/SingleProductImages/wooden-rocking-chair.jpg"
import SingleProduct18 from "../images/SingleProductImages/wooden-study-table.jpg"



const ProductsData = [
    {
        pid: 1,
        pImg: Product1,
        pLargeImg: SingleProduct1,
        pCategory: "Armchair",
        pTitle: "Armchair with Head Rester",
        pPrice: "62.50",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 2,
        pImg: Product2,
        pLargeImg: SingleProduct2,
        pCategory: "Sofa",
        pTitle: "Sofa Chairs with Red Cushions",
        pPrice: "450.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 3,
        pImg: Product3,
        pLargeImg: SingleProduct3,
        pCategory: "Chair",
        pTitle: "Fancy Single Chair",
        pPrice: "199.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 4,
        pImg: Product4,
        pLargeImg: SingleProduct4,
        pCategory: "Chair",
        pTitle: "Wingback Yellow Couch",
        pPrice: "186.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 5,
        pImg: Product5,
        pLargeImg: SingleProduct5,
        pCategory: "Study table",
        pTitle: "Corner Study Table with Chair",
        pPrice: "459.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 6,
        pImg: Product6,
        pLargeImg: SingleProduct6,
        pCategory: "Table",
        pTitle: "Dinning Table for Two",
        pPrice: "360.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 7,
        pImg: Product7,
        pLargeImg: SingleProduct7,
        pCategory: "Sofa",
        pTitle: "Fancy Chairs",
        pPrice: "380.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 8,
        pImg: Product8,
        pLargeImg: SingleProduct8,
        pCategory: "Chair",
        pTitle: "Vintage Luxury Chair",
        pPrice: "429.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 9,
        pImg: Product9,
        pLargeImg: SingleProduct9,
        pCategory: "Computer table",
        pTitle: "Computer Table with Office Chair",
        pPrice: "775.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 10,
        pImg: Product10,
        pLargeImg: SingleProduct10,
        pCategory: "Chair",
        pTitle: "Orange Recliner with Leg Rest",
        pPrice: "419.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 11,
        pImg: Product11,
        pLargeImg: SingleProduct11,
        pCategory: "Sofa",
        pTitle: "Modern White Round Sofa",
        pPrice: "599.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 12,
        pImg: Product12,
        pLargeImg: SingleProduct12,
        pCategory: "Chair",
        pTitle: "Round Short Leg Stool/Chair",
        pPrice: "229.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 13,
        pImg: Product13,
        pLargeImg: SingleProduct13,
        pCategory: "Sofa",
        pTitle: "Sofa Chairs with Cushions",
        pPrice: "325.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 14,
        pImg: Product14,
        pLargeImg: SingleProduct14,
        pCategory: "Sofa",
        pTitle: "Beige Living Room Sofa",
        pPrice: "599.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 15,
        pImg: Product15,
        pLargeImg: SingleProduct15,
        pCategory: "Computer table",
        pTitle: "Desktop Table with Drawers",
        pPrice: "529.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 16,
        pImg: Product16,
        pLargeImg: SingleProduct16,
        pCategory: "Stool",
        pTitle: "Classic Wooden Table",
        pPrice: "85.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 17,
        pImg: Product17,
        pLargeImg: SingleProduct17,
        pCategory: "Armchair",
        pTitle: "Wooden Rocking Chair",
        pPrice: "169.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    },
    {
        pid: 18,
        pImg: Product18,
        pLargeImg: SingleProduct18,
        pCategory: "Study table",
        pTitle: "Study Table",
        pPrice: "385.00",
        pShortDesc: "Habitasse eaque wisi molestie, mollis pharetra convallis exercitation, distinctio eu arcu fugit nibh donec exercitationem, quisque imperdiet mattis proident c.",
        pLongDesc: "Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu felis dapibus condimentum sit amet a augue. Sed non neque elit sed.",
    }

];

export default ProductsData;